module.exports = __webpack_public_path__ + "img/bg-3_word.56087ea7.jpg";